import cloneDeep from 'lodash/cloneDeep'
import { makeDefaultGetters, makeDefaultMutations, setState } from '@/utilities/store'
import { send, sendAndSet } from '@/utilities/store'
import { bporDecodeSearchString } from '@/utilities/org'
import api from '@/utilities/api'
import store from '@/plugins/store'

  const params1 = new URLSearchParams(window.location.search);
  const defaultDistance = params1.get("distance")

const defaultState = () => ({
  allCategoriesAndTags: [],
  distanceCounts: {},
  filter: {
    ageRange: [],
    distance: defaultDistance?Number.parseInt(defaultDistance):20,
    gender: [],
    studyStatus: ['Recruiting'],
    updatedWithin: null,
  },
  geolocation: { latitude: null, longitude: null },
  offset: 0,
  openUrl: 'yes',
  query: '*',
  results: null,
  rows: 10,
  search: '',
  selectedCategory: null,
  selectedTag: null,
  showFilterOnMobile: false,
  sortBy: 'relevance',
  sortOrder: null,
  wasClicked: 0,
  wasClickedCat: 0,
})

const properties = () => Object.keys(defaultState())

const defaultGetters = makeDefaultGetters(properties())

const defaultMutations = makeDefaultMutations(properties(), defaultState())

const state = defaultState()

const getters = {
  ...defaultGetters,
  decodedSearchString: s => bporDecodeSearchString(s.search),
  facets: s => s.results?.data?.facets || [],
  hasLocation: s => s.geolocation?.latitude && s.geolocation?.longitude,
  params: s => {
    const getLatLon = f => {
      const { latitude, longitude } = f
      if (latitude && longitude) return `${latitude},${longitude}`
      else return ''
    }
    const getSortBy = sb => {
      switch (sb) {
        case 'distance':
          return 'distance'
        case 'mostRecent':
          return 'lastUpdatedDate'
        case 'relevance':
          return null
        case 'titleAZ':
          return 'publicTitle'
        default:
          return null
      }
    }
    const getSortOrder = sb => {
      switch (sb) {
        case 'distance':
          return 'asc'
        case 'mostRecent':
          return 'desc'
        case 'relevance':
          return null
        case 'titleAZ':
          return 'asc'
        default:
          return null
      }
    }
    const filter = cloneDeep(s.filter)
    const selectedCategory = s.selectedCategory?.name
    const selectedTag = s.selectedTag?.text
    return {
      dist: filter.distance,
      facetDef: {
        Gender: filter.gender?.length ? filter.gender : null,
        'Study Status': filter.studyStatus?.length ? filter.studyStatus : null,
        'Updated Within': filter.updatedWithin,
        'Age Range': filter.ageRange?.length ? filter.ageRange : null,
        'Health Tag': selectedTag ? [selectedTag] : null,
        'Health Category': selectedCategory && !selectedTag ? [selectedCategory] : null,
      },
      latLon: getLatLon(s.geolocation),
      offset: s.offset,
      openurl: s.openUrl,
      query: s.query,
      rows: s.rows,
      sortBy: getSortBy(s.sortBy),
      sortOrder: getSortOrder(s.sortBy),
    }
  },
  studies: s => s.results?.data?.results || [],
}

const actions = {
  async fetchDistanceCounts({ commit }, p = {}) {
    const payload = { json: true, method: 'POST', prefix: 'search', ...p }
    const res = await api('/json-params/filter', payload)
    if (res?.data?.data) commit('setDistanceCounts', res?.data?.data)
    return res
  },
  async fetchMore({ commit, getters }, infiniteState) {
    const { offset, params, rows } = getters
    const newOffset = Number.parseInt(offset) + Number.parseInt(rows)
    commit('setOffset', newOffset)
    const data = { ...params, offset: newOffset }
    const payload = { data, json: true, method: 'POST', prefix: 'search' }
    const res = await api('/json-params/cd', payload)
    const newResults = Array.isArray(res?.data?.data?.results) ? res.data.data.results : []
    commit('addResults', newResults)
    console.log(infiniteState)
    infiniteState.loaded()
    
  },
  async fetchResults({ commit, dispatch }, p = {}) {
    commit('setOffset', 0)
    const payload = { json: true, method: 'POST', prefix: 'search', url: '/json-params/cd', ...p }
    return await dispatch('sendAndSet', { mutation: 'setResults', payload, reset: false })
    // .finally(
    //   // setTimeout(()=>{store.commit('core/setIsLoading',true )}, 1000)
    //   store.commit('core/setIsLoading',true )
    // )
  },
  send,
  sendAndSet,
}

const mutations = {
  ...defaultMutations,
  addResults: (state, payload) => {
    payload.forEach(r => {
      state.results.data.results.push(r)
    })
  },
  resetState: state => setState(state, defaultState(), true),
}

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
}
